module.exports = __webpack_public_path__ + "static/media/ic_comm_gray.ff35c0a1.svg";